<template>
  <div class="calcSocials">
    <div class="footerSocials">
      <a
        v-if="profile.telegram"
        :href="`https://t.me/${profile.telegram}`"
        :title="`${profile.telegram}`"
        class="footerSocials__link"
        target="_blank"
      >
        <icon-tg class="footerSocials__icon" />
      </a>
      <a
        v-if="profile.skype"
        :href="`skype://${profile.skype}`"
        :title="`${profile.skype}`"
        class="footerSocials__link"
        target="_blank"
      >
        <icon-skype class="footerSocials__icon" />
      </a>
      <a
        v-if="profile.instagram"
        :href="profile.instagram"
        class="footerSocials__link"
        target="_blank"
      >
        <icon-instagram class="footerSocials__icon" />
      </a>
      <a
        v-if="profile.youtube"
        :href="profile.youtube"
        title="PLC ULTIMA"
        class="footerSocials__link"
        target="_blank"
      >
        <icon-youtube class="footerSocials__icon" />
      </a>
      <a
        v-if="profile.facebook"
        :href="profile.facebook"
        title="plcultima"
        target="_blank"
        class="footerSocials__link"
      >
        <icon-facebook class="footerSocials__icon" />
      </a>
      <a
        v-if="profile.twitter"
        :href="profile.twitter"
        title="@PlcUltima"
        target="_blank"
        class="footerSocials__link"
      >
        <icon-twitter class="footerSocials__icon" />
      </a>
    </div>
    <div class="calcSocials__actions">
      <a
        :href="toRegistration"
        target="_blank"
        class="calcSocials__btn calcSocials__btn--reg btnFarm btnFarm--outline-white"
        >{{ $t(`Registration`) }}</a
      >
      <a
        :href="toSite"
        target="_blank"
        class="calcSocials__btn btnFarm btnFarm--outline-white"
        >{{ $t(`Get More Info`) }}</a
      >
    </div>
  </div>
</template>

<script>
import IconFacebook from "@/assets/img/socials/icon-facebook.svg?inline";
import IconTg from "@/assets/img/socials/icon-tg.svg?inline";
import IconTwitter from "@/assets/img/socials/icon-tw.svg?inline";
import IconYoutube from "@/assets/img/socials/icon-youtube.svg?inline";
import IconSkype from "@/assets/img/socials/icon-skype.svg?inline";
import IconInstagram from "@/assets/img/socials/icon-insta.svg?inline";

export default {
  name: "CalcSocials",
  components: {
    IconFacebook,
    IconTg,
    IconTwitter,
    IconYoutube,
    IconSkype,
    IconInstagram,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  computed: {
    toRegistration() {
      const mainUrl = this.$store.getters.getConfig.domainUltimaFarm;
      return (
        mainUrl +
        "/{locale}/registration/{referral}"
          .replace("{locale}", this.$i18n.locale)
          .replace("{referral}", this.profile.inviteCode)
      );
    },
    toSite() {
      const mainUrl = this.$store.getters.getConfig.domainUltimaFarm;
      return mainUrl + "/" + this.$i18n.locale + "/" + this.profile.inviteCode;
    },
  },
};
</script>

<style lang="scss" scoped>
.calcSocials {
  background: $color-secondary;
  border-radius: 10px;
  box-shadow: 0 -15px 50px rgba(0, 0, 0, 0.1);
  padding: 22px 16px 32px;

  @media (min-width: $breakpoint-md) {
    padding: 32px;
    text-align: center;
  }

  &__actions {
    display: grid;
    gap: 8px;
    margin-top: 24px;

    @media (min-width: $breakpoint-md) {
      gap: 16px;
      grid-template-columns: repeat(2, minmax(164px, max-content));
      justify-content: center;
      margin-top: 16px;
    }

    @media (min-width: $breakpoint-xl) {
      grid-template-columns: repeat(2, minmax(174px, max-content));
    }
  }

  &__btn {
    &--reg {
      @media (min-width: $breakpoint-md) {
        order: 1;
      }
    }
  }
}

.footerSocials {
  display: flex;
  gap: 16px;
  justify-content: center;

  &__link {
    cursor: pointer;
    display: flex;
    opacity: 0.5;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &__icon {
    height: 24px;
    width: 24px;

    ::v-deep path {
      fill: #649af1;
    }
  }
}
</style>
